import { render, staticRenderFns } from "./ifp-filter-priorities.vue?vue&type=template&id=b52fa5c4&"
import script from "./ifp-filter-priorities.vue?vue&type=script&lang=ts&"
export * from "./ifp-filter-priorities.vue?vue&type=script&lang=ts&"
import style0 from "./ifp-filter-priorities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports